<template>
  <div class="page update-protocol">
    <navigation class="white navigation">协议更新</navigation>

    <!-- 更新内容 -->
    <section class="content">
      <div class="block">
        <p class="title">【敬请阅读】</p>
        <p class="text">亲爱的天美贷用户，服务协议有更新哦！</p>
        <p class="text">协议中有对您权利义务特别的约定以及管理约定等 重要条款，请您务必仔细阅读哦！</p>
      </div>

      <div class="block">
        <p class="title">【特别提示】</p>
        <p class="text">如您继续使用我们的服务，表示您已充分阅读、理 解并接受协议的全部内容，阅读协议的过程中，如 果您有任何疑问，可向平台客服询问，如您不同意 协议中的任何条款，您应立即停止使用服务。</p>
      </div>

      <div class="protocol-list">

      </div>

      <nd-button @click="agreement">同意上述协议，并继续使用天美贷</nd-button>
    </section>
  </div>
</template>
<script>
export default {
  name: 'update-protocol',
  created () {
    this.$bus.$emit('ready')
  },
  methods: {
    agreement () {
      this.$report({
        id: 10066
      })
    },

    viewProtocol (row) {
      this.$report({
        id: 10067,
        args: {
          target: row.name
        }
      })
    }
  }
}
</script>
<style lang="less">
@import "../../assets/less/mixin.less";

    .page.update-protocol {
        .navigation {
            background: linear-gradient(90deg,rgba(255,51,51,1) 0%,rgba(255,95,52,1) 100%);
        }

        .content {
            .block {
                padding: 0 40px 0 50px;
                margin-top: 84px;

                .title {
                    margin-left: -0.5em;
                    font-size: 32px;
                    font-family: PingFangSC-Medium,PingFang SC;
                    font-weight: 500;
                    line-height: 45px;
                    margin-bottom: 15px;
                }

                .text {
                    font-size: 30px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;
                    line-height: 42px;
                    color: @fc2;
                }
            }

            .nd-button {
                margin: 0 auto;
                margin-top: 113px;
            }
        }
    }
</style>